wbApp.factory('subjectsSvc', ['$resource', '$q', 'repositorySvc', 'tenantInfoSvc',
    function ($resource, $q, repositorySvc, tenantInfoSvc) {
        var Subject = $resource('/Api/Subjects/GetAll', {}, {
            'query':  { method: 'GET', isArray: true },
            'update': { method: 'POST', url: '/Api/Subjects/Update' },
            'insert': { method: 'POST', url: '/Api/Subjects/Insert' },
            'delete': { method: 'POST', url: '/Api/Subjects/Delete' },
            'getAllFranchiseCentralCourseSubjects': { method: 'GET', url: '/Api/Subjects/getAllFranchiseCentralCourseSubjects', isArray: true },
            'getAllActiveFranchiseSubjects': { method: 'GET', url: '/Api/Subjects/getAllActiveFranchiseSubjects', isArray: true },
        });

        var subjects;
        var subjectsForCourses;
        var subjectsForActions;

        function createNew(subjectCategoryID) {
            return {
                id: 0,
                name: "",
                description: "",
                subjectCategoryID: subjectCategoryID || 1,
                isNew: true
            };
        }

        function getAllWithActiveFranchiesesAsync(reload, subjectIDtoInclude) {

            var sIDs = !!subjectIDtoInclude ? subjectIDtoInclude : 0;

            var allSubjects = getAllForCoursesAsync(reload);
            var filteredSubjects = [];           

            var deffered = $q.defer();
            filteredSubjects.$promise = deffered.promise;

            allSubjects.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    // franchiseCentralTenantID

                    var include = false;

                    if (!!value.franchiseCentralTenantID) {
                        include =
                            (!!_.filter(tenantInfoSvc.info.franchiseCentrals, { tenantID: value.franchiseCentralTenantID, isActive: true }).length) ||
                            (value.id === sIDs);
                    } else {
                        include = true;
                    }

                    if (include) {
                        filteredSubjects.push(value);
                    }
                });
                deffered.resolve(filteredSubjects);
            }, function (reason) {
                deffered.reject(reason);
            });

            return filteredSubjects;
        }

        function getAllAsync(reload) {
            if (!subjects || reload) {
                subjects = repositorySvc.get(Subject, {});
            }
            return subjects;
        }

        function getAllBySubjectCategory(subjectCategoryID, reload) {
            var allSubjects = getAllAsync(reload);
            var filteredSubjects = [];

            var deffered = $q.defer();
            filteredSubjects.$promise = deffered.promise;

            allSubjects.$promise.then(function (data) {
                angular.forEach(data, function (value, key) {
                    if (value.subjectCategoryID === subjectCategoryID) {
                        filteredSubjects.push(value);
                    }
                });
                deffered.resolve(filteredSubjects);
            }, function (reason) {
                deffered.reject(reason);
            });

            return filteredSubjects;
        }

        function getAllForCoursesAsync(reload) {
            if (!subjectsForCourses || reload) {
                subjectsForCourses = getAllBySubjectCategory(1, reload);
            }
            return subjectsForCourses;
        }

        function getAllForActionsAsync(reload) {
            if (!subjectsForActions || reload) {
                subjectsForActions = getAllBySubjectCategory(2, reload);
            }

            return subjectsForActions;
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                Subject,               // $resource
                subjects,              // collection
                data,                  // entity
                success,
                errorCallback);

            function success(entity) {
                if (entity.subjectCategoryID === 1) {
                    repositorySvc.entityInserted(subjectsForCourses, entity);
                }

                if (entity.subjectCategoryID === 2) {
                    repositorySvc.entityInserted(subjectsForActions, entity);
                }

                if (successCallback) {
                    successCallback(entity);
                }
            }
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                Subject,            // $resource
                subjects,           // collection
                data,               // entity
                success,
                errorCallback);

            function success(entity) {

                if (entity.subjectCategoryID === 1) {
                    repositorySvc.entityUpdated(subjectsForCourses, entity);
                }

                if (entity.subjectCategoryID === 2) {
                    repositorySvc.entityUpdated(subjectsForActions, entity);
                }

                if (successCallback) {
                    successCallback(entity);
                }
            }
        }

        function remove(data, errorCallback) {
            repositorySvc.remove(
                Subject,               // $resource
                subjects,              // collection
                data,                  // entity
                success,                  // successCallback
                errorCallback);

            function success() {
                if (data.subjectCategoryID === 1) {
                    repositorySvc.entityRemoved(subjectsForCourses, data.id);
                }

                if (data.subjectCategoryID === 2) {
                    repositorySvc.entityRemoved(subjectsForActions, data.id);
                }
            }
        }

        function getAllFranchiseCentralCourseSubjects(franchiseCentralTenantID, refresh) {

            return repositorySvc.customGet(
                'getAllFranchiseCentralCourseSubjects',
                Subject,
                {
                    franchiseCentralTenantID: franchiseCentralTenantID
                });
        }

        function getFranchiseCentralSubject(franchiseCentralTenantID, franchiseCentralSubjectID) {
            var deffered = $q.defer();
            var frs = getAllFranchiseCentralCourseSubjects(franchiseCentralTenantID);
            frs.$promise.then(function (data) {
                var subject = _.find(data, { 'id': franchiseCentralSubjectID });
                deffered.resolve(subject);
            }, function (error) {
                deffered.reject(error);
            });

            return deffered.promise;
        }

        function getAllActiveFranchiseSubjects()
        {
            return repositorySvc.customGet(
                'getAllActiveFranchiseSubjects',
                Subject,
                {});
        }

        return {
            getAllFranchiseCentralCourseSubjects: getAllFranchiseCentralCourseSubjects,
            getFranchiseCentralSubject: getFranchiseCentralSubject,
            getAllAsync: getAllAsync,
            getAllForCoursesAsync: getAllForCoursesAsync,
            getAllForActionsAsync: getAllForActionsAsync,
            getAllWithActiveFranchiesesAsync: getAllWithActiveFranchiesesAsync,
            insert: insert,
            update: update,
            remove: remove,
            createNew: createNew,
            getAllActiveFranchiseSubjects: getAllActiveFranchiseSubjects
        }
    }
]);
